import ITask from '../../../Utility/Task/ITask';
import BaseUISystem from '../BaseUISystem';
import BaseUIHandler from '../BaseUIHandler';
import { IUIState } from '../../../State/UI/IUIState';

export default class HidePopupTask implements ITask<BaseUISystem> {
    private state: IUIState;
    private handler: BaseUIHandler;

    constructor(handler: BaseUIHandler, state: IUIState) {
        this.state = state;
        this.handler = handler;
    }

    public *execute(system: BaseUISystem): IterableIterator<number> {
        yield* this.handler.hide(this.state);
        this.handler.destroy();
    }
}
